<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/country">Countries</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.name }}
            </h1>
        </div>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
                    <text-input v-model="form.country_code" :error="form.errors.country_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Country code" />
                    <text-input v-model="form.number_prefix" :error="form.errors.country_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Phone number prefix" />
                    <select-input v-model="form.language_code" :error="form.errors.language_code"  class="pb-8 pr-6 w-full lg:w-1/2" label="Language">
                        <option value="en">EN</option>
                        <option value="de">DE</option>
                    </select-input>
                    <select-input v-model="form.is_enabled" :error="form.errors.language_code"  class="pb-8 pr-6 w-full lg:w-1/2" label="Is enabled">
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                    </select-input>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Update Country
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import throttle from 'lodash/throttle'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        country: Object
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.country.name,
                country_code: this.country.country_code,
                number_prefix: this.country.number_prefix,
                language_code: this.country.language_code,
                is_enabled: this.country.is_enabled
            }),
            responses: []
        }
    },
    methods: {
        update() {
            this.form.post(`/country/${this.country.id}`)
        }
    },
}
</script>
